module.exports = __webpack_public_path__ + "static/classic-education-centre-a843c75523b6aa0c39b9a3efbf9fe15a.png";